import dayjs from "dayjs";

export default val => {
  return val ? dayjs(val).format("YYYY-MM-DD HH:mm:ss") : "";
};



// WEBPACK FOOTER //
// ./src/filters/timeFormat.js